import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login/LoginNew.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/',
        name: 'Index',
        component: () => import('@/views/Index'),
        redirect: '/login',
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/home/Home')
            },
            {
                path: '/sys/menu',
                name: 'MenuManagement',
                component: () => import('@/views/system/MenuManagement')
            },
            {
                path:'/sys/user/index',
                name:"UserManagement",
                component:() => import('@/views/system/UserManagement')
            },
            {
                path:'/sys/role', // 角色管理
                name:"RoleManagement",
                component:() => import('@/views/system/RoleManagement')
            },
            {
                path: '/sys/dict/', // 字典管理
                name: 'dictionaries',
                component: () => import('@/views/system/dictionaries')
            },
            {
                path:'/sys/Institutional',//组织机构
                name:'Institutional',
                component:() => import('@/views/system/Institutional/Institutional')
            },
            {
                path:'/sys/SystemConfig',// 系统配置
                name:'SystemConfig',
                component:()=>import('@/views/system/SystemMenu/SystemConfig')
            },
            {
                path: '/wy/wyProject/index',  // 项目列表
                name: 'ProjectManagement',
                component:()=>import('@/views/property/ProjectManagement')
            },
            {
                path: '/wy/wyFloor/index', // 楼宇管理
                name: 'BuildingManagement',
                component:()=>import('@/views/property/BuildingManagement')
            },
            {
                path: '/wy/room/index', // 房间管理
                name: 'RoomManagement',
                component:()=>import('@/views/property/RoomManagement')
            },
            {
                path: '/wy/roomcheckRefuse/index',
                name: 'RoomRefuseBinding',
                component:()=>import('@/views/property/RoomRefuseBinding')
            },
            {
                path: '/wy/roomcheck/index', // 房产待绑定
                name: 'RoomStayBinding',
                component:()=>import('@/views/property/RoomStayBinding')
            },
            {
                path: '/wy/roomCheckNew/index', // 房产已绑定
                name: 'RoomWinBinding',
                component:()=>import('@/views/property/RoomWinBinding')
            }, 
            {
                path: '/wy/CorporateEstateRefuse/index', //企业已拒绝
                name: 'CompanyRoomRefuseBinding',
                component:()=>import('@/views/property/CompanyRoomRefuseBinding')
            },
            {
                path: '/wy/CorporateEstate/index', // 企业房产待绑定
                name: 'CompanyRoomStayBinding',
                component:()=>import('@/views/property/CompanyRoomStayBinding')
            },
            {
                path: '/wy/CorporateEstateNew/index', // 房产已绑定
                name: 'CompanyRoomWinBinding',
                component:()=>import('@/views/property/CompanyRoomWinBinding')
            },
            {
                path: '/crm/customer/index',// 业主信息列表
                name: 'OwnerInformation',
                component:()=>import('@/views/Clientele/OwnerInformation')
            },
            {
                path: "/accounting/subjects", // 会计科目设置
                name: 'AccountingManagement',
                component:()=>import('@/views/charge/AccountingManagement')
            },
            {
                path: '/charge/method',// 收款方式设置
                name: 'ChargeSet',
                component:()=>import('@/views/charge/ChargeSet')
            },
            {
                path: '/charge/feeItem',// 收费项目设置
                name: 'ChargeItemList',
                component:()=>import('@/views/charge/ChargeItemList')
            },
            {
                path: '/accounting/taxControlPanel/index',//开票项目设置
                name: 'InvoiceItem',
                component:()=>import('@/views/charge/InvoiceItem')
            },  {
                path: '/charge/feeRoom/index', // 收费标准设置
                name: 'RoomCharge',
                component:()=>import('@/views/charge/RoomCharge')
            },
            {
                path: '/charge/invoicetype', // 票据类型设置
                name: 'BillSet',
                component:()=>import('@/views/charge/BillSet')
            },
            {
                path: '/charge/invoicegroup',// 票据管理组设置
                name: 'BillManagement',
                component:()=>import('@/views/charge/BillManagement')
            },
            {
                path: '/charge/invoicepeople/index',// 票据管理人员设置
                name: 'BillManager',
                component:()=>import('@/views/charge/BillManager')
            },
            {
                path: '/charge/invoicegroup/positonIndex',// 票据管理部门
                name: 'BillsDepartmen',
                component:()=>import('@/views/charge/BillsDepartmen')
            },
            {
                path: '/charge/invoicegroup/typeIndex',// 票据管理类型设置
                name: 'BillType',
                component:()=>import('@/views/charge/BillType')
            },
            {
                path: '/charge/chargeInvoiceShared/index',// 票据共享部门
                name: 'BillShareDepartment',
                component:()=>import('@/views/charge/BillShareDepartment')
            },
            {
                path: '/charge/invoiceInhouse/index', // 票据入库
                name: 'BillStorage',
                component:()=>import('@/views/charge/BillStorage')
            },
            {
                path: '/charge/distribution/list',// 票据分配
                name: 'BillAllocation',
                component:()=>import('@/views/charge/BillAllocation')
            },
            {
                path: '/charge/BillAllocationAlready',// 已分配定额票据
                name: 'BillAllocationAlready',
                component:()=>import('@/views/charge/BillAllocationAlready')
            },
            {
                path: '/charge/invoiceInhouse/useIndex', // 票据领用
                name: 'BillReceive',
                component:()=>import('@/views/charge/BillReceive')
            },
            {
                path: '/charge/canlcellation/index',// 票据核销
                name: 'BillNucleus',
                component:()=>import('@/views/charge/BillNucleus')
            },
            {
                path: '/charge/BillNucleusAlready',// 票据已核销
                name: 'BillNucleusAlready',
                component:()=>import('@/views/charge/BillNucleusAlready')
            },
            {
                path: '/charge/bills/dailyIndex', // 日常收费处理
                name: 'DailyCharge',
                component:()=>import('@/views/charge/DailyCharge')
            },
            {
                path: '/charge/bills/index',// 应收账单生成
                name: 'ReceivableBill',
                component:()=>import('@/views/charge/ReceivableBill')
            },
            {
                path: '/charge/bills/depositIndex', // 押金
                name: 'CashPledge',
                component:()=>import('@/views/charge/CashPledge')
            },
            {
                path: '/charge/bills/CashPledgeDel', // 押金
                name: 'CashPledgeDel',
                component:()=>import('@/views/charge/CashPledgeDel')
            },
            {
                path: '/charge/adjustment/index',// 应收账调整
                name: 'Receivable',
                component:()=>import('@/views/charge/Receivable')
            },
            {
                path: '/charge/prompt/index',// 催缴通知单打印
                name: 'payment',
                component:()=>import('@/views/charge/payment')
            },
            {
                path: '/cha/ElseCharge',
                name: 'ElseCharge',
                component:()=>import('@/views/charge/ElseCharge')
            },
            {
                path: '/cha/ChargSituation',
                name: 'ChargSituation',
                component:()=>import('@/views/charge/ChargSituation')
            },
            {
                path: '/charge/report/index', //  日报表
                name: 'CollectionDay',
                component:()=>import('@/views/statement/CollectionDay')
            },
            {
                path: '/charge/collect/shIndex', //  日汇总
                name: 'CollectionDayGather',
                component:()=>import('@/views/statement/CollectionDayGather')
            },
            {
                path: '/charge/deposit/index',//报表 押金
                name: 'DepositRepor',
                component:()=>import('@/views/statement/DepositRepor')
            },
            {
                path: '/charge/invalidInvoice/index', // 票据作废报表
                name: 'BillInvalid',
                component:()=>import('@/views/statement/BillInvalid')
            },
            {
                path: '/charge/offlineInvoice/index', // 线下电子报表
                name: 'OfflineList',
                component:()=>import('@/views/statement/OfflineList')
            },
            {
                path: '/charge/annualSummary/index', // 实收年度
                name: 'AnnualSummary',
                component:()=>import('@/views/statement/AnnualSummary')
            },
            {
                path:'/polling/InspectionClassification',//巡检分类
                name:'InspectionClassification',
                component:()=>import('@/views/polling/InspectionClassification')
            },
            {
                path:'/polling/InspectionStandard',//巡检标准
                name:'InspectionStandard',
                component:()=>import('@/views/polling/InspectionStandard')
            },
            {
                path: 'meter/basic/index', // 仪表基础信息
                name: 'MeterBasicIndex',
                component:()=>import('@/views/meter/basic/Index')
            },
            {
                path: 'meter/charge/detail/index', // 仪表详情
                name: 'MeterDetailIndex',
                component:()=>import('@/views/meter/charge/detail/Index')
            },
            {
                path: 'meter/charge/order/index', // 仪表账单
                name: 'MeterOrderIndex',
                component:()=>import('@/views/meter/charge/order/Index')
            },
            {
                path: 'meter/charge/order/invoice/index', // 仪表账单发票页面，不需要菜单
                name: 'MeterOrderInvoiceIndex',
                component:()=>import('@/views/meter/charge/order/components/Invoice')
            },
            {
                path: 'meter/charge/report/index', // 缴费报表
                name: 'MeterReportIndex',
                component:()=>import('@/views/meter/charge/report/Index')
            },
            {
                path: 'meter/charge/feeitem/index', // 仪表收费项
                name: 'MeterFeeitemIndex',
                component:()=>import('@/views/meter/charge/feeitem/Index')
            },
            {
                path: 'meter/charge/readtimeout/index', // 超时仪表
                name: 'MeterReadTimeoutIndex',
                component:()=>import('@/views/meter/charge/readtimeout/Index')
            },
            {
                path: 'meter/charge/usedata/index', // 智能表使用量
                name: 'MeterUseDataIndex',
                component:()=>import('@/views/meter/charge/usedata/Index')
            },
            {
                path: 'meter/charge/message/index', // 短信记录
                name: 'MeterMessageIndex',
                component:()=>import('@/views/meter/charge/message/Index')
            },
            {
                path:'/polling/LevelManagement',//点位管理
                name:'LevelManagement',
                component:()=>import('@/views/polling/LevelManagement')
            },
            {
                path:'/polling/PollingAllocation',//巡检分配
                name:'PollingAllocation',
                component:()=>import('@/views/polling/PollingAllocation')
            },
            {
                path:'/polling/PollingTask',//巡检任务
                name:'PollingTask',
                component:()=>import('@/views/polling/PollingTask')
            },
            {
                path:'/polling/PollingRecord',//巡检记录
                name:'PollingRecord',
                component:()=>import('@/views/polling/PollingRecord')
            },
            {
                path:'/polling/PollingTaskRecord',//巡检任务记录
                name:'PollingTaskRecord',
                component:()=>import('@/views/polling/PollingTaskRecord')
            },
            {
                path:'/polling/AbnormalWork',//异常工单
                name:'AbnormalWork',
                component:()=>import('@/views/polling/AbnormalWork')
            },
            {
                path:'/polling/PointStatistical',//巡检统计
                name:'PointStatistical',
                component:()=>import('@/views/polling/PointStatistical')
            },
            {
                path:'/Icon/IconManagement',//图标管理
                name:'IconManagement',
                component:()=>import('@/views/Icon/IconManagement')
            },{
                // PostManagement
                path:'/system/PostManagement',//岗位管理 -员工
                name:'PostManagement',
                component:()=>import('@/views/system/PostManagement')
            },
            {
                path:'/car/monthcardList',// 月卡列表
                name:'MonthCardList',
                component:()=>import('@/views/car/monthcardList/Index')
            },
            {
                path:'/car/renewalFeeAudit',// 续费审核
                name:'RenewalFeeAudit',
                component:()=>import('@/views/car/renewalFeeAudit/Index')
            },
            {
                path:'/car/openCardAudit',// 开卡审核
                name:'OpenCardAudit',
                component:()=>import('@/views/car/openCardAudit/Index')
            },
            {
                path:'/car/modifyRecord',// 车牌修改记录
                name:'ModifyRecord',
                component:()=>import('@/views/car/modifyRecord/Index')
            },
        ]
    },
    {
        path: '/forget/password',
        name: 'forgetPassword',
        component: () => import('@/views/login/ForgetPassword')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/Register')
    },
    {
        path: '/test',
        name:'test',
        component:()=>import('@/views/common/OrganizationalStructure')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
